"use client";

import { motion } from "framer-motion";
import { fadeInUp, staggerContainer } from "@/lib/animations";
import { Users, Briefcase, Award, Coffee } from "lucide-react";
import AnimatedCounter from "../ui/AnimatedCounter";

const stats = [
  {
    icon: Users,
    value: 500,
    suffix: "+",
    label: "Active Members",
    color: "text-blue-500 dark:text-blue-400",
    bgColor: "bg-blue-500/10",
  },
  {
    icon: Briefcase,
    value: 1200,
    suffix: "+",
    label: "Projects Completed",
    color: "text-primary",
    bgColor: "bg-primary/10",
  },
  {
    icon: Award,
    value: 150,
    suffix: "+",
    label: "Events Hosted",
    color: "text-purple-500 dark:text-purple-400",
    bgColor: "bg-purple-500/10",
  },
  {
    icon: Coffee,
    value: 10000,
    suffix: "+",
    label: "Cups of Coffee",
    color: "text-orange-500 dark:text-orange-400",
    bgColor: "bg-orange-500/10",
  },
];

export default function Stats() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-7xl">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 lg:gap-10"
        >
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="text-center px-2 sm:px-0"
            >
              <div
                className={`inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 rounded-xl sm:rounded-2xl ${stat.bgColor} mb-3 sm:mb-4`}
              >
                <stat.icon
                  className={`w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 ${stat.color}`}
                />
              </div>
              <div
                className={`text-3xl sm:text-4xl md:text-5xl font-bold mb-1.5 sm:mb-2 ${stat.color}`}
              >
                <AnimatedCounter value={stat.value} suffix={stat.suffix} />
              </div>
              <p className="text-text text-xs sm:text-sm md:text-base leading-tight sm:leading-normal">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
